import { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";

const WatchlistContext = createContext(null);
const KEY = "tt_watchlist";

export const WatchlistProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = useCallback(
    (id) => setIds((cur) => (cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id])),
    []
  );
  const has = useCallback((id) => ids.includes(id), [ids]);

  const value = useMemo(() => ({ ids, toggle, has, count: ids.length }), [ids, toggle, has]);

  return <WatchlistContext.Provider value={value}>{children}</WatchlistContext.Provider>;
};

export const useWatchlist = () =>
  useContext(WatchlistContext) || { ids: [], toggle: () => {}, has: () => false, count: 0 };
